// flag if the config fields represents a service
// (this is needed as we currently mix services and other settings in our global config)
const serviceConfig = {
  stage: false,
  monolithUrl: false,
  angularUrl: false,
  monolithApiUrl: true,
  organisationService: true,
  iipService: true,
  organisationRegistration: true,
  capacityManagement: true,
  authentication: false,
  surrenderService: true,
  contractManagement: true,
  documentExchange: true,
  gasDataManagement: true,
  snamBidCollector: true,
  transparencyReporting: true,
  directFcfs: true,
  regularFcfs: true,
  hydrogenFcfs: true,
  remitReporting: true,
  productFruitsTestAccounts: false,
  networkPoints: true,
  authorizationService: true,
  lngMarketing: true,
  assignmentService: true,
  transportAuction: true,
  exchangerateService: true,
  secondaryMarketService: true,
  ttpcModulationService: true,
  notificationService: true,
  storageService: true,
  reshuffleService: true,
} satisfies Record<keyof typeof PRISMA_CONFIG, boolean>;

type ServiceConfig = typeof serviceConfig;
type ServiceConfigKeys = keyof ServiceConfig;

export type Service = {
  [K in ServiceConfigKeys]: ServiceConfig[K] extends true ? K : never;
}[ServiceConfigKeys];

export const services = Object.entries(serviceConfig).reduce(
  (acc, [key, value]) => (value ? [...acc, key as Service] : acc),
  [] as Service[]
);

export const teams = {
  Carma: 'Carma',
  Rupert: 'Rupert',
  Otters: 'Otters',
  MonolithShared: 'MonolithShared',
  Zen: 'Zen',
  Lynx: 'Lynx',
  Paddington: 'Paddington',
} as const;

export type Team = keyof typeof teams;

export const ownershipMapper = {
  assignmentService: teams.Rupert,
  authorizationService: teams.Carma,
  capacityManagement: teams.Carma,
  contractManagement: teams.Carma,
  directFcfs: teams.Lynx,
  documentExchange: teams.Rupert,
  gasDataManagement: teams.Zen,
  iipService: teams.Carma,
  lngMarketing: teams.Paddington,
  monolithApiUrl: teams.MonolithShared,
  networkPoints: teams.Otters,
  organisationRegistration: teams.Rupert,
  organisationService: teams.Rupert,
  regularFcfs: teams.Lynx,
  hydrogenFcfs: teams.Zen,
  remitReporting: teams.Zen,
  reshuffleService: teams.Carma,
  snamBidCollector: teams.Otters,
  surrenderService: teams.Carma,
  transparencyReporting: teams.Zen,
  transportAuction: teams.Otters,
  exchangerateService: teams.Rupert,
  secondaryMarketService: teams.Otters,
  ttpcModulationService: teams.Carma,
  notificationService: teams.Rupert,
  storageService: teams.Paddington,
} as const satisfies Record<Service, Team>;
